import { connect } from 'react-redux'
import { deleteEmailTemplate } from 'src/legacy/redux/actions/emailTemplate.jsx'  
import DeleteEmailTemplateView from './DeleteEmailTemplateView.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import _ from 'lodash';

const mapStateToProps = (state,ownProps) => {
  return {
    emailTemplates: _.get(state.legacyRootReducer, "settings.emailTemplate.items"),
    deleting: _.get(state.legacyRootReducer, "settings.emailTemplate.template.deleting"),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteEmailTemplate: (id) => {
      return dispatch(deleteEmailTemplate(id));
    }
  }
}

const DeleteEmailTemplateContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteEmailTemplateView)

export default withUseHooks(DeleteEmailTemplateContainer);